// extracted by mini-css-extract-plugin
export default {"tooltip":"_1T4r","error":"_1CLt","close_icon":"_3Vud"};